import { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import '../../App.css';
import logo from '../../Carters-Logo.png';
import { Wave1 } from '../animations/wave';
import {Button} from'antd'

export default withOktaAuth(class Home extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }

  async login() {
    await this.props.oktaAuth.signInWithRedirect();
  }

  async logout() {
    await this.props.oktaAuth.signOut();
  }

  render() {
    let body = null;
    if (this.props.authState?.isAuthenticated) {
      body = (
        <div className="Buttons">
          <Button onClick={this.logout}>Logout</Button>
          {/* Replace me with your root component. */}
        </div>
      );
    } else {
      body = (
        <div className="Buttons">
          <Button className='loginbutton' onClick={this.login}>Login</Button>
        </div>
      );
    }

    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo"/>
          <p>
             <Wave1/>
          </p>
          {body}
        </header>
      </div>
    );
  }
});
